import {styled} from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

export const Label = styled(Typography)(({theme}) => ({
  color: theme.colorz.secondary.main,
  fontSize: 14,
  lineHeight: 1.5,
  letterSpacing: .2
}))
